import React from "react";

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20 22H18V20C18 19.2044 17.6839 18.4413 17.1213 17.8787C16.5587 17.3161 15.7956 17 15 17H9C8.20435 17 7.44129 17.3161 6.87868 17.8787C6.31607 18.4413 6 19.2044 6 20V22H4V20C4 18.6739 4.52678 17.4021 5.46447 16.4645C6.40215 15.5268 7.67392 15 9 15H15C16.3261 15 17.5979 15.5268 18.5355 16.4645C19.4732 17.4021 20 18.6739 20 20V22ZM12 13C11.2121 13 10.4319 12.8448 9.7039 12.5433C8.97595 12.2417 8.31451 11.7998 7.75736 11.2426C7.20021 10.6855 6.75825 10.0241 6.45672 9.2961C6.15519 8.56815 6 7.78793 6 7C6 6.21207 6.15519 5.43185 6.45672 4.7039C6.75825 3.97595 7.20021 3.31451 7.75736 2.75736C8.31451 2.20021 8.97595 1.75825 9.7039 1.45672C10.4319 1.15519 11.2121 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7C18 8.5913 17.3679 10.1174 16.2426 11.2426C15.1174 12.3679 13.5913 13 12 13ZM12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11Z" />
  </svg>
);

export const UserHappyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M17.9996 17V22H15.9996V17C15.9996 12.549 18.6436 8.715 22.4466 6.984L23.2746 8.804C21.7013 9.51958 20.3673 10.6729 19.4319 12.1263C18.4965 13.5797 17.9993 15.2716 17.9996 17ZM7.99961 17V22H5.99961V17C5.99976 15.2718 5.50244 13.5801 4.56705 12.1269C3.63166 10.6737 2.29774 9.52051 0.724609 8.805L1.55261 6.984C3.4753 7.85849 5.10561 9.26796 6.24883 11.0441C7.39205 12.8201 7.99984 14.8878 7.99961 17ZM11.9996 12C10.6735 12 9.40176 11.4732 8.46408 10.5355C7.52639 9.59785 6.99961 8.32608 6.99961 7C6.99961 5.67392 7.52639 4.40215 8.46408 3.46447C9.40176 2.52678 10.6735 2 11.9996 2C13.3257 2 14.5975 2.52678 15.5351 3.46447C16.4728 4.40215 16.9996 5.67392 16.9996 7C16.9996 8.32608 16.4728 9.59785 15.5351 10.5355C14.5975 11.4732 13.3257 12 11.9996 12ZM11.9996 10C12.3936 10 12.7837 9.9224 13.1477 9.77164C13.5116 9.62087 13.8424 9.3999 14.1209 9.12132C14.3995 8.84274 14.6205 8.51203 14.7712 8.14805C14.922 7.78407 14.9996 7.39397 14.9996 7C14.9996 6.60603 14.922 6.21593 14.7712 5.85195C14.6205 5.48797 14.3995 5.15726 14.1209 4.87868C13.8424 4.6001 13.5116 4.37913 13.1477 4.22836C12.7837 4.0776 12.3936 4 11.9996 4C11.204 4 10.4409 4.31607 9.87829 4.87868C9.31568 5.44129 8.99961 6.20435 8.99961 7C8.99961 7.79565 9.31568 8.55871 9.87829 9.12132C10.4409 9.68393 11.204 10 11.9996 10Z" />
  </svg>
);

export const DurationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM15.536 7.05L16.95 8.464L12 13.414L10.586 12L15.536 7.05Z" />
  </svg>
);

export const CarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M19 20H5V21C5 21.2652 4.89464 21.5196 4.70711 21.7071C4.51957 21.8946 4.26522 22 4 22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V13.5L0.757 13.19C0.540753 13.1358 0.348809 13.011 0.211655 12.8352C0.0745022 12.6595 5.86043e-06 12.4429 0 12.22L0 11.5C0 11.3674 0.0526784 11.2402 0.146447 11.1464C0.240215 11.0527 0.367392 11 0.5 11H2L4.48 5.212C4.63432 4.852 4.89096 4.54524 5.21805 4.32978C5.54515 4.11432 5.92832 3.99965 6.32 4H17.68C18.0713 4.00004 18.4541 4.1149 18.7808 4.33033C19.1075 4.54577 19.3638 4.85231 19.518 5.212L22 11H23.5C23.6326 11 23.7598 11.0527 23.8536 11.1464C23.9473 11.2402 24 11.3674 24 11.5V12.22C24 12.4429 23.9255 12.6595 23.7883 12.8352C23.6512 13.011 23.4592 13.1358 23.243 13.19L22 13.5V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H20C19.7348 22 19.4804 21.8946 19.2929 21.7071C19.1054 21.5196 19 21.2652 19 21V20ZM20 18V13H4V18H20ZM5.477 11H18.523C18.6863 10.9999 18.8471 10.9598 18.9914 10.8832C19.1357 10.8066 19.2589 10.6958 19.3505 10.5605C19.442 10.4253 19.4991 10.2697 19.5166 10.1073C19.5341 9.94488 19.5116 9.78067 19.451 9.629L18 6H6L4.549 9.629C4.4884 9.78067 4.46588 9.94488 4.4834 10.1073C4.50092 10.2697 4.55795 10.4253 4.64951 10.5605C4.74106 10.6958 4.86435 10.8066 5.0086 10.8832C5.15285 10.9598 5.31367 10.9999 5.477 11ZM5 14C7.317 14 8.879 14.755 9.686 16.264C9.72679 16.3402 9.74714 16.4257 9.74506 16.5121C9.74297 16.5985 9.71852 16.6829 9.6741 16.757C9.62968 16.8311 9.5668 16.8925 9.49159 16.9351C9.41639 16.9777 9.33143 17 9.245 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16V14ZM19 14V16C19 16.2652 18.8946 16.5196 18.7071 16.7071C18.5196 16.8946 18.2652 17 18 17H14.755C14.6687 16.9999 14.5838 16.9774 14.5088 16.9347C14.4337 16.892 14.3709 16.8307 14.3266 16.7566C14.2823 16.6825 14.258 16.5981 14.2559 16.5118C14.2539 16.4255 14.2742 16.3401 14.315 16.264C15.12 14.754 16.682 14 19 14Z" />
  </svg>
);

export const CalanderIocn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM15 5H9V7H7V5H4V9H20V5H17V7H15V5ZM20 11H4V19H20V11ZM6 14H8V16H6V14ZM10 14H18V16H10V14Z" />
  </svg>
);

export const SubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11 11H12H13H19V13H13H12H11H5V11H11Z" />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" />
  </svg>
);

export const LineArrow = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 36.1 25.8"
    enableBackground="new 0 0 36.1 25.8"
    xmlSpace="preserve"
  >
    <g>
      <line
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeMiterlimit="10"
        x1="0"
        y1="12.9"
        x2="34"
        y2="12.9"
      ></line>
      <polyline
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeMiterlimit="10"
        points="22.2,1.1 34,12.9 22.2,24.7   "
      ></polyline>
    </g>
  </svg>
);


export const ExclamationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="0 0 286.054 286.054"
    fill="currentColor"
  >
    <path d="M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027   c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236   c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209   S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972   c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723   c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843   C160.878,195.732,152.878,187.723,143.036,187.723z" />
  </svg>
);

export const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21.397" height="20.3" viewBox="0 0 21.397 20.3">
    <g transform="translate(0.198 -15.867)">
      <path
        d="M55.793,204.6H41.882A1.9,1.9,0,0,1,40,202.688v-10.06a.655.655,0,1,1,1.309,0v10.06a.578.578,0,0,0,.573.582H55.793a.578.578,0,0,0,.573-.582v-10.06a.655.655,0,1,1,1.309,0v10.06A1.9,1.9,0,0,1,55.793,204.6Z"
        transform="translate(-38.337 -168.583)"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.3"
      />
      <path
        d="M20.344,26.323a.65.65,0,0,1-.464-.195l-8.162-8.271a1.708,1.708,0,0,0-2.436,0L1.121,26.128a.65.65,0,0,1-.928,0,.671.671,0,0,1,0-.941l8.162-8.271a3.01,3.01,0,0,1,4.292,0l8.162,8.271a.671.671,0,0,1,0,.941.65.65,0,0,1-.464.195Z"
        transform="translate(0)"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.3"
      />
      <path
        d="M181.986,296.629h-5.321a.665.665,0,0,1-.665-.665v-5.9a2.081,2.081,0,0,1,2.078-2.078h2.494a2.081,2.081,0,0,1,2.078,2.078v5.9A.665.665,0,0,1,181.986,296.629Zm-4.656-1.33h3.99v-5.237a.749.749,0,0,0-.748-.748h-2.494a.749.749,0,0,0-.748.748Z"
        transform="translate(-168.825 -260.612)"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.3"
      />
    </g>
  </svg>
);

export const InvoiceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">
    <path
      d="M12.5,20H2.5A2.5,2.5,0,0,1,0,17.5V2.5A2.5,2.5,0,0,1,2.5,0H8.333a.833.833,0,0,1,.589.244l5.834,5.833A.828.828,0,0,1,15,6.667V17.5A2.5,2.5,0,0,1,12.5,20ZM2.5,1.666a.835.835,0,0,0-.834.834v15a.835.835,0,0,0,.834.834h10a.835.835,0,0,0,.834-.834V7.5H10A2.5,2.5,0,0,1,7.5,5V1.666ZM9.167,2.845V5A.834.834,0,0,0,10,5.833h2.154ZM10,15.833H5a.833.833,0,1,1,0-1.666h5a.833.833,0,0,1,0,1.666ZM7.5,12.5H5a.833.833,0,1,1,0-1.666H7.5a.833.833,0,0,1,0,1.666Z"
      fill="currentColor"
    />
  </svg>
);

export const RafflesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36.667" height="20" viewBox="0 0 36.667 20">
    <g id="Group_2311" data-name="Group 2311" transform="translate(-370 -319)">
      <path
        d="M405,323.508a6.641,6.641,0,0,1-3.267-2.842,6.831,6.831,0,0,1-.692-1.667H375.625a6.831,6.831,0,0,1-.692,1.667,6.641,6.641,0,0,1-3.267,2.842,6.552,6.552,0,0,1-1.667.442v10.258a6.831,6.831,0,0,1,1.667.692,6.681,6.681,0,0,1,2.433,2.433,6.832,6.832,0,0,1,.692,1.667h25.417a6.831,6.831,0,0,1,.692-1.667,6.706,6.706,0,0,1,4.1-3.125,6.866,6.866,0,0,1,1.667-.208V323.95A6.552,6.552,0,0,1,405,323.508Zm0,8.992a8.348,8.348,0,0,0-5.967,4.833H375.967a8.393,8.393,0,0,0-4.3-4.3v-7.75a8.366,8.366,0,0,0,5.133-4.617h23.067A8.366,8.366,0,0,0,405,325.283Z"
        transform="translate(0 0)"
        fill="currentColor"
      />
      <g id="Group_2306" data-name="Group 2306" transform="translate(378.333 323.167)">
        <path
          d="M380,324v5h1.111v-3.889H385V324Z"
          transform="translate(-380 -324)"
          fill="currentColor"
        />
      </g>
      <g id="Group_2307" data-name="Group 2307" transform="translate(393.333 323.167)">
        <path
          d="M403,324v5h-1.111v-3.889H398V324Z"
          transform="translate(-398 -324)"
          fill="currentColor"
        />
      </g>
      <g id="Group_2308" data-name="Group 2308" transform="translate(378.333 329.833)">
        <path
          d="M380,337v-5h1.111v3.889H385V337Z"
          transform="translate(-380 -332)"
          fill="currentColor"
        />
      </g>
      <g id="Group_2309" data-name="Group 2309" transform="translate(393.333 329.833)">
        <path
          d="M403,337v-5h-1.111v3.889H398V337Z"
          transform="translate(-398 -332)"
          fill="currentColor"
        />
      </g>
      <path
        d="M391.167,326.5l1.288,2.469,2.879.4-2.083,1.922.492,2.714-2.575-1.281L388.592,334l.492-2.714L387,329.365l2.879-.4Z"
        transform="translate(-2.833 -1.25)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const VoucherIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="20" viewBox="0 0 26 20">
    <g id="coupon" transform="translate(0 -59.411)">
      <path
        d="M23.562,79.411H2.438A2.472,2.472,0,0,1,0,76.911V72.744a.823.823,0,0,1,.813-.833,2.5,2.5,0,0,0,0-5A.823.823,0,0,1,0,66.078V61.911a2.472,2.472,0,0,1,2.438-2.5H23.563A2.472,2.472,0,0,1,26,61.911v4.167a.823.823,0,0,1-.813.833,2.5,2.5,0,0,0,0,5,.823.823,0,0,1,.813.833v4.167A2.472,2.472,0,0,1,23.562,79.411ZM1.625,73.494v3.417a.824.824,0,0,0,.813.833H23.563a.824.824,0,0,0,.813-.833V73.494a4.19,4.19,0,0,1,0-8.166V61.911a.824.824,0,0,0-.813-.833H2.438a.824.824,0,0,0-.813.833v3.417a4.19,4.19,0,0,1,0,8.166Z"
        fill="currentColor"
      />
      <path
        d="M0,0H14.24V1.667H0Z"
        transform="translate(9.72 75.774) rotate(-69.444)"
        fill="currentColor"
      />
      <path
        d="M121.323,153.529a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,121.323,153.529Zm0-3.333a.833.833,0,1,0,.833.833A.834.834,0,0,0,121.323,150.2Z"
        transform="translate(-112.144 -83.837)"
        fill="currentColor"
      />
      <path
        d="M269.852,242.646a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,269.852,242.646Zm0-3.333a.833.833,0,1,0,.833.833A.834.834,0,0,0,269.852,239.313Z"
        transform="translate(-252.324 -167.786)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const WavePattern = () => (
  <svg
    className="wave-pattern"
    xmlns="http://www.w3.org/2000/svg"
    width="414"
    height="137"
    viewBox="0 0 414 137"
    fill="none"
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="414"
      height="137"
    >
      <rect width="414" height="137" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <path
        opacity="0.3"
        d="M574 -27.1553C571.769 -25.5087 570.706 -21.3833 569.83 -18.7983C567.758 -12.7253 565.917 -7.02406 562.021 -1.9514C548.289 15.9224 527.013 21.4288 505.906 18.711C479.017 15.2407 456.324 -2.81898 428.763 -1.34056C419.847 -0.862511 410.825 1.66054 403.68 7.34403C395.207 14.081 391.001 25.1027 391.772 36.2042C392.648 48.846 402.706 58.8231 407.062 70.3228C411.87 83.0178 411.843 97.855 406.336 110.222C400.076 124.289 384.618 133.381 369.823 136.099C353.966 139.012 335.479 134.851 323.438 123.776C304.916 106.752 314.522 81.9554 304.969 61.3284C296.85 43.7999 276.646 37.4701 258.54 39.7541C238.955 42.2241 222.726 51.8294 208.684 66.1089C195.74 79.273 184.691 94.6149 170.1 105.876C157.164 115.862 142.467 123.28 126.982 127.477C92.6998 136.754 51.636 130.345 22.8612 107.814C-3.7975 86.9396 -20.7259 53.8124 -28.2516 19.9947C-29.2167 15.6657 -36.344 -36.194 -33.1124 -36.194C-32.829 -36.194 -34.2456 -38 -33.9623 -38L574 -27.1553Z"
        fill="#e94661"
      />
      <path
        opacity="0.05"
        d="M428.135 -48.2303C423.862 -44.8497 407.108 -44.7879 401.74 -42.8725C391.492 -39.2094 382.108 -33.0572 374.86 -24.9189C357.858 -5.8355 349.243 27.8826 319.564 31.0161C293.055 33.8142 274.809 11.1383 250.595 5.25089C200.401 -6.95649 157.931 23.4604 117.448 49.1198C68.1196 80.3929 10.8816 98.4877 -43.1609 65.2551C-83.0968 40.6902 -90 -0.460018 -90 -44.3201L390.035 -45.2381C394.228 -45.2381 400.257 -47.2153 404.318 -47.992C408.758 -48.8394 412.872 -49.8368 417.374 -49.828C421.399 -49.8191 425.328 -50.4723 429 -49.2895C428.832 -48.9012 428.541 -48.5481 428.135 -48.2303Z"
        fill="#e25f33"
      />
    </g>
  </svg>
);

export const UserAccount = () => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width="36.667"
    height="20"
    viewBox="0 0 36.667 20">
    <g
      id="Group_2311"
      data-name="Group 2311"
      transform="translate(-370 -319)">
      <path
        d="M405,323.508a6.641,6.641,0,0,1-3.267-2.842,6.831,6.831,0,0,1-.692-1.667H375.625a6.831,6.831,0,0,1-.692,1.667,6.641,6.641,0,0,1-3.267,2.842,6.552,6.552,0,0,1-1.667.442v10.258a6.831,6.831,0,0,1,1.667.692,6.681,6.681,0,0,1,2.433,2.433,6.832,6.832,0,0,1,.692,1.667h25.417a6.831,6.831,0,0,1,.692-1.667,6.706,6.706,0,0,1,4.1-3.125,6.866,6.866,0,0,1,1.667-.208V323.95A6.552,6.552,0,0,1,405,323.508Zm0,8.992a8.348,8.348,0,0,0-5.967,4.833H375.967a8.393,8.393,0,0,0-4.3-4.3v-7.75a8.366,8.366,0,0,0,5.133-4.617h23.067A8.366,8.366,0,0,0,405,325.283Z"
        transform="translate(0 0)"
        fill="currentColor">
      </path>
      <g
        id="Group_2306"
        data-name="Group 2306"
        transform="translate(378.333 323.167)">
        <path
          d="M380,324v5h1.111v-3.889H385V324Z"
          transform="translate(-380 -324)"
          fill="currentColor">
        </path>
      </g>
      <g
        id="Group_2307"
        data-name="Group 2307"
        transform="translate(393.333 323.167)">
        <path
          d="M403,324v5h-1.111v-3.889H398V324Z"
          transform="translate(-398 -324)"
          fill="currentColor">
        </path>
      </g>
      <g
        id="Group_2308"
        data-name="Group 2308"
        transform="translate(378.333 329.833)">
        <path
          d="M380,337v-5h1.111v3.889H385V337Z"
          transform="translate(-380 -332)"
          fill="currentColor">
        </path>
      </g>
      <g
        id="Group_2309"
        data-name="Group 2309"
        transform="translate(393.333 329.833)">
        <path
          d="M403,337v-5h-1.111v3.889H398V337Z"
          transform="translate(-398 -332)"
          fill="currentColor">
        </path>
      </g>
      <path
        d="M391.167,326.5l1.288,2.469,2.879.4-2.083,1.922.492,2.714-2.575-1.281L388.592,334l.492-2.714L387,329.365l2.879-.4Z"
        transform="translate(-2.833 -1.25)"
        fill="currentColor">
      </path>
    </g>
  </svg>
);

export const NotificationInvoice = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="58" height="58">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
  </svg>
);

export const NotificationVoucher = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="58" height="58">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"></path>
  </svg>
);

export const NotificationTicket = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="58" height="58">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
  </svg>
);
export const ArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g>
      <path
        d="M16.2541 4.24106C16.5522 4.53326 16.5793 4.99051 16.3354 5.31272L16.2541 5.40503L9.52658 12L16.2541 18.595C16.5522 18.8872 16.5793 19.3444 16.3354 19.6666L16.2541 19.7589C15.956 20.0511 15.4896 20.0777 15.161 19.8386L15.0668 19.7589L7.7459 12.582C7.44784 12.2898 7.42074 11.8325 7.66461 11.5103L7.7459 11.418L15.0668 4.24106C15.3947 3.91965 15.9262 3.91965 16.2541 4.24106Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M7.7459 19.7589C7.44784 19.4667 7.42074 19.0095 7.66461 18.6873L7.7459 18.595L14.4734 12L7.7459 5.40503C7.44784 5.11283 7.42074 4.65558 7.66461 4.33338L7.7459 4.24106C8.04396 3.94887 8.51037 3.9223 8.83904 4.16137L8.93321 4.24106L16.2541 11.418C16.5522 11.7102 16.5793 12.1675 16.3354 12.4897L16.2541 12.582L8.93321 19.7589C8.60534 20.0804 8.07376 20.0804 7.7459 19.7589Z"
      fill="currentColor"
    />
  </svg>
);

export const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M5.625 4.375V0H4.375V4.375H0V5.625H4.375V10H5.625V5.625H10V4.375H5.625Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const MinusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="2" viewBox="0 0 11 2" fill="none">
    <path d="M0.166504 0.166672H10.1665V1.66667H0.166504V0.166672Z" fill="#4F4F4F" />
  </svg>
);

export const TickSquareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3343 2.0002C19.7381 2.0002 22.0003 4.42971 22.0003 7.9162V16.0842C22.0003 19.5709 19.7379 22.0002 16.3333 22.0002H7.66531C4.26167 22.0002 2.00031 19.5709 2.00031 16.0842V7.9162C2.00031 4.4328 4.26773 2.0002 7.66531 2.0002H16.3343ZM16.3343 3.5002H7.66531C5.12064 3.5002 3.50031 5.23857 3.50031 7.9162V16.0842C3.50031 18.7655 5.11506 20.5002 7.66531 20.5002H16.3333C18.8847 20.5002 20.5003 18.7654 20.5003 16.0842V7.9162C20.5003 5.23517 18.8848 3.5002 16.3343 3.5002ZM16.0901 9.09687C16.3564 9.36314 16.3806 9.7798 16.1628 10.0734L16.0901 10.1575L11.3441 14.9035C11.0779 15.1698 10.6613 15.194 10.3677 14.9762L10.2836 14.9036L7.90959 12.5306C7.61663 12.2378 7.61653 11.7629 7.90936 11.47C8.17557 11.2037 8.59223 11.1794 8.88589 11.3972L8.97002 11.4698L10.8129 13.312L15.0295 9.09687C15.3224 8.80398 15.7972 8.80398 16.0901 9.09687Z"
      fill="currentColor"
    />
  </svg>
);
export const FluentFoodIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4 3.6C11.5404 3.59995 11.6764 3.64916 11.7843 3.73907C11.8922 3.82897 11.9651 3.95386 11.9904 4.092L12 4.2V7.8C12.0001 8.49159 11.7613 9.16199 11.324 9.69774C10.8866 10.2335 10.2776 10.6017 9.6 10.74V19.8C9.60028 19.9499 9.54441 20.0945 9.44339 20.2053C9.34238 20.3161 9.20354 20.3851 9.05422 20.3986C8.90489 20.4122 8.75591 20.3693 8.6366 20.2785C8.5173 20.1877 8.43631 20.0555 8.4096 19.908L8.4 19.8V10.74C7.757 10.6085 7.17483 10.2698 6.74266 9.7759C6.31049 9.28196 6.05215 8.65997 6.0072 8.0052L6 7.8V4.2C5.99973 4.05006 6.0556 3.90546 6.15661 3.79466C6.25763 3.68386 6.39646 3.6149 6.54579 3.60135C6.69511 3.5878 6.84409 3.63065 6.9634 3.72146C7.08271 3.81227 7.16369 3.94446 7.1904 4.092L7.2 4.2V7.8C7.19981 8.17239 7.31511 8.53568 7.53004 8.83979C7.74496 9.1439 8.04891 9.37387 8.4 9.498V4.2C8.39973 4.05006 8.4556 3.90546 8.55661 3.79466C8.65763 3.68386 8.79647 3.6149 8.94579 3.60135C9.09511 3.5878 9.24409 3.63065 9.3634 3.72146C9.48271 3.81227 9.56369 3.94446 9.5904 4.092L9.6 4.2V9.4968C10.2456 9.2688 10.722 8.6832 10.7916 7.9788L10.8 7.8V4.2C10.8 4.04087 10.8632 3.88826 10.9757 3.77573C11.0883 3.66321 11.2409 3.6 11.4 3.6ZM17.4 3.6C17.5404 3.59995 17.6764 3.64916 17.7843 3.73907C17.8922 3.82897 17.9651 3.95386 17.9904 4.092L18 4.2V19.8C18.0003 19.9499 17.9444 20.0945 17.8434 20.2053C17.7424 20.3161 17.6035 20.3851 17.4542 20.3986C17.3049 20.4122 17.1559 20.3693 17.0366 20.2785C16.9173 20.1877 16.8363 20.0555 16.8096 19.908L16.8 19.8V13.2H15C14.8596 13.2 14.7236 13.1508 14.6157 13.0609C14.5078 12.971 14.4349 12.8461 14.4096 12.708L14.4 12.6V6.6C14.4 5.80435 14.7161 5.04129 15.2787 4.47868C15.8413 3.91607 16.6044 3.6 17.4 3.6ZM16.8 12V4.902C16.1544 5.13 15.678 5.7156 15.6084 6.4212L15.6 6.6V12H16.8V4.902V12Z"
      fill="currentColor"
    />
  </svg>
);
export const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.7326 2C16.0831 2 16.3728 2.26247 16.4186 2.603L16.4249 2.69767L16.425 3.48627C19.2681 3.68121 21.009 5.51888 21 8.48579V16.9744C21 20.1193 19.0453 22 15.9036 22H8.09625C4.95834 22 3 20.0872 3 16.9041V8.48579C3 5.51995 4.74651 3.68177 7.58344 3.48635L7.58353 2.69767C7.58353 2.31236 7.89348 2 8.27583 2C8.62632 2 8.91598 2.26247 8.96182 2.603L8.96814 2.69767L8.968 3.469H15.04L15.0403 2.69767C15.0403 2.31236 15.3503 2 15.7326 2ZM19.615 10.283H4.384L4.38461 16.9041C4.38461 19.2292 5.62916 20.5198 7.86897 20.6006L8.09625 20.6047H15.9036C18.2946 20.6047 19.6154 19.3338 19.6154 16.9744L19.615 10.283ZM16.1089 16.136C16.4912 16.136 16.8012 16.4484 16.8012 16.8337C16.8012 17.1869 16.5407 17.4788 16.2028 17.525L16.1089 17.5314C15.718 17.5314 15.408 17.219 15.408 16.8337C15.408 16.4805 15.6685 16.1886 16.0064 16.1424L16.1089 16.136ZM12.0128 16.136C12.3951 16.136 12.7051 16.4484 12.7051 16.8337C12.7051 17.1869 12.4446 17.4788 12.1067 17.525L12.0128 17.5314C11.6219 17.5314 11.3119 17.219 11.3119 16.8337C11.3119 16.4805 11.5724 16.1886 11.9103 16.1424L12.0128 16.136ZM7.90812 16.136C8.29047 16.136 8.60043 16.4484 8.60043 16.8337C8.60043 17.1869 8.33998 17.4788 8.00207 17.525L7.89957 17.5314C7.51722 17.5314 7.20727 17.219 7.20727 16.8337C7.20727 16.4805 7.46772 16.1886 7.80563 16.1424L7.90812 16.136ZM16.1089 12.5206C16.4912 12.5206 16.8012 12.833 16.8012 13.2183C16.8012 13.5715 16.5407 13.8634 16.2028 13.9096L16.1089 13.916C15.718 13.916 15.408 13.6036 15.408 13.2183C15.408 12.8651 15.6685 12.5732 16.0064 12.527L16.1089 12.5206ZM12.0128 12.5206C12.3951 12.5206 12.7051 12.833 12.7051 13.2183C12.7051 13.5715 12.4446 13.8634 12.1067 13.9096L12.0128 13.916C11.6219 13.916 11.3119 13.6036 11.3119 13.2183C11.3119 12.8651 11.5724 12.5732 11.9103 12.527L12.0128 12.5206ZM7.90812 12.5206C8.29047 12.5206 8.60043 12.833 8.60043 13.2183C8.60043 13.5715 8.33998 13.8634 8.00207 13.9096L7.89957 13.916C7.51722 13.916 7.20727 13.6036 7.20727 13.2183C7.20727 12.8651 7.46772 12.5732 7.80563 12.527L7.90812 12.5206ZM15.04 4.864H8.968L8.96814 5.75887C8.96814 6.14418 8.65818 6.45654 8.27583 6.45654C7.92535 6.45654 7.63569 6.19407 7.58985 5.85354L7.58353 5.75887L7.58255 4.88521C5.51889 5.05837 4.38461 6.3066 4.38461 8.48579L4.384 8.887H19.615L19.6154 8.48365C19.622 6.30275 18.4935 5.05711 16.4249 4.88499L16.4249 5.75887C16.4249 6.14418 16.115 6.45654 15.7326 6.45654C15.3821 6.45654 15.0925 6.19407 15.0466 5.85354L15.0403 5.75887L15.04 4.864Z"
      fill="currentColor"
    />
  </svg>
);
export const UsersIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.59131 14.4563L9.91109 14.4577C14.5555 14.4981 17.1833 15.4361 17.1833 17.9983C17.1833 20.5062 14.6648 21.4736 10.2234 21.5547L9.59131 21.5603C4.74697 21.5603 2.00031 20.6394 2.00031 18.0183C2.00031 15.3938 4.7579 14.4563 9.59131 14.4563ZM9.59131 15.9563C5.57395 15.9563 3.50031 16.6612 3.50031 18.0183C3.50031 19.3667 5.56898 20.0603 9.59131 20.0603C13.6089 20.0603 15.6833 19.3553 15.6833 17.9983C15.6833 16.6506 13.6127 15.9563 9.59131 15.9563ZM17.587 13.7481C18.1676 13.7876 18.7448 13.8708 19.2994 13.9938C20.4875 14.2301 21.3708 14.6713 21.7755 15.5204C22.0743 16.1492 22.0743 16.8806 21.7755 17.5093C21.3731 18.3563 20.499 18.7943 19.3042 19.04C18.8985 19.1235 18.5019 18.8622 18.4185 18.4565C18.335 18.0508 18.5963 17.6542 19.002 17.5708C19.7708 17.4126 20.2826 17.1562 20.4207 16.8654C20.5259 16.6442 20.5259 16.3856 20.4211 16.1651C20.282 15.8732 19.7676 15.6163 18.991 15.4617C18.4936 15.3516 17.9908 15.2791 17.4852 15.2447C17.072 15.2166 16.7597 14.8588 16.7878 14.4455C16.8159 14.0323 17.1737 13.72 17.587 13.7481ZM9.59131 2.4998C12.4393 2.4998 14.7263 4.78641 14.7263 7.6338C14.7263 10.482 12.4395 12.7688 9.59131 12.7688C6.74323 12.7688 4.45731 10.4822 4.45731 7.6338C4.45731 4.78627 6.74341 2.4998 9.59131 2.4998ZM16.02 3.5694C18.2549 3.5694 20.067 5.38188 20.067 7.6164C20.067 9.85161 18.2552 11.6634 16.02 11.6634C15.6058 11.6634 15.27 11.3276 15.27 10.9134C15.27 10.4992 15.6058 10.1634 16.02 10.1634C17.4268 10.1634 18.567 9.02319 18.567 7.6164C18.567 6.21023 17.4264 5.0694 16.02 5.0694C15.6058 5.0694 15.27 4.73362 15.27 4.3194C15.27 3.90519 15.6058 3.5694 16.02 3.5694ZM9.59131 3.9998C7.57189 3.9998 5.95731 5.61464 5.95731 7.6338C5.95731 9.65383 7.57176 11.2688 9.59131 11.2688C11.6111 11.2688 13.2263 9.65359 13.2263 7.6338C13.2263 5.61489 11.611 3.9998 9.59131 3.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const SubPackageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
      fill="currentColor"
    />
  </svg>
);

export const TimeSlotIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      fill="currentColor"
    />
  </svg>
);
export const TransportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  version="1.1"
  xmlSpace="preserve"
  width="1em"
  height="1em"
  viewBox="0 0 366 366"
  fill="currentColor">
    <g>
      <g>
        <g>
          <path d="M312,123.2c0-0.4,0-0.8,0-1.2l-18.4-82.8c-4-18.4-20.4-31.6-39.2-31.6H77.6c-18.8,0-35.2,13.2-39.2,31.6L20,122.4
				c-0.4,1.2-0.4,2,0,3.2c-12,6.8-20,20-20,34.8v80c0,12.4,6.8,22.8,16.4,30c0,0.4-0.4,1.2-0.4,2v28c0,15.6,12.4,28,28,28h8
				c15.6,0,28-12.4,28-28v-20h176v20c0,15.6,12.4,28,28,28h8c15.6,0,28-12.4,28-28v-28c9.6-7.2,16-18.8,16-32V160
				C336,143.6,326,129.6,312,123.2z M54.4,42.8C56.8,32,66.4,24,77.6,24h176.8c11.2,0,21.2,8,23.2,18.8l17.2,77.2H40
				c-0.8,0-2,0-2.8,0L54.4,42.8z M64,300c0,6.8-5.2,12-12,12h-8c-6.8,0-12-5.2-12-12v-22c4,1.2,8,2,12,2h20V300z M304,300
				c0,6.8-5.2,12-12,12h-8c-6.8,0-12-5.2-12-12v-20h24c2.8,0,5.6-0.4,8-0.8V300z M320,240c0,13.2-10.8,24-24,24H44
				c-12.8,0-28-10.8-28-24v-80c0-13.2,10.8-24,24-24h256c13.2,0,24,10.8,24,24V240z"/>
          <path d="M60,172c-13.2,0-24,10.8-24,24s10.8,24,24,24s24-10.8,24-24S73.2,172,60,172z M60,204c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8
				c4.4,0,8,3.6,8,8C68,200.4,64.4,204,60,204z"/>
          <path d="M276,172c-13.2,0-24,10.8-24,24s10.8,24,24,24s24-10.8,24-24S289.2,172,276,172z M276,204c-4.4,0-8-3.6-8-8
				c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8C284,200.4,280.4,204,276,204z"/>
        </g>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>

);